import './libs/slider_object.js';
import './common.js';

import './libs/media/media.js';

import '../scss/complex_object.scss';
